/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorDelinquentReports.vue?vue&type=template&id=070d234f"
import script from "./DoctorDelinquentReports.vue?vue&type=script&lang=js"
export * from "./DoctorDelinquentReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070d234f')) {
      api.createRecord('070d234f', component.options)
    } else {
      api.reload('070d234f', component.options)
    }
    module.hot.accept("./DoctorDelinquentReports.vue?vue&type=template&id=070d234f", function () {
      api.rerender('070d234f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/DoctorDelinquentReports.vue"
export default component.exports